import { SET_USER_PERMISSIONS } from "../Action/loginAction";

const initialState = {
    permissions: null,
};

const permissionReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_USER_PERMISSIONS:
            return {
                ...state,
                permissions: action.payload,
            };
        default:
            return state;
    }
};

export default permissionReducer;